/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Guest_Welcome_PackInputs */

const en_doc_type_guest_welcome_pack = /** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest Welcome Pack`)
};

const id_doc_type_guest_welcome_pack = /** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Sambutan Tamu`)
};

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const es_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const fr_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const de_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const ja_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const zh_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const ar_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const it_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const ru_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const pt_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/** @type {(inputs: Doc_Type_Guest_Welcome_PackInputs) => LocalizedString} */
const ko_doc_type_guest_welcome_pack = en_doc_type_guest_welcome_pack;

/**
* | output |
* | --- |
* | "Guest Welcome Pack" |
*
* @param {Doc_Type_Guest_Welcome_PackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_guest_welcome_pack = /** @type {((inputs?: Doc_Type_Guest_Welcome_PackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Guest_Welcome_PackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_guest_welcome_pack(inputs)
	if (locale === "es") return es_doc_type_guest_welcome_pack(inputs)
	if (locale === "fr") return fr_doc_type_guest_welcome_pack(inputs)
	if (locale === "de") return de_doc_type_guest_welcome_pack(inputs)
	if (locale === "ja") return ja_doc_type_guest_welcome_pack(inputs)
	if (locale === "zh") return zh_doc_type_guest_welcome_pack(inputs)
	if (locale === "ar") return ar_doc_type_guest_welcome_pack(inputs)
	if (locale === "id") return id_doc_type_guest_welcome_pack(inputs)
	if (locale === "it") return it_doc_type_guest_welcome_pack(inputs)
	if (locale === "ru") return ru_doc_type_guest_welcome_pack(inputs)
	if (locale === "pt") return pt_doc_type_guest_welcome_pack(inputs)
	return ko_doc_type_guest_welcome_pack(inputs)
});